import BusinessIcon from '@mui/icons-material/Business'
import HourglassTopIcon from '@mui/icons-material/HourglassTop'
import InterestsIcon from '@mui/icons-material/Interests'
import PersonIcon from '@mui/icons-material/Person'
import SchoolIcon from '@mui/icons-material/School'
import WorkIcon from '@mui/icons-material/Work'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import {grey} from '@mui/material/colors'
import {emToAbsoluteUrl} from 'utilities/extensionMethods'

export default function EmptyStateCard({
  title,
  subTitle,
  size,
  elevation,
  align,
  img,
  p,
  m,
  bgcolor,
  titleColor,
  children,
}: {
  title?: string
  subTitle?: string
  size?: string
  elevation?: number
  align?: string
  img?:
    | 'folder'
    | 'wind'
    | 'profile'
    | 'education'
    | 'experience'
    | 'certifications'
    | 'interests'
    | 'business'
    | 'loading'
  p?: number
  m?: number
  bgcolor?: string
  titleColor?: string
  children?: React.ReactNode
}) {
  return (
    <Card
      elevation={elevation ? elevation : 0}
      sx={{
        textAlign: align ? align : 'center',
        padding: p ? p : 0,
        margin: m ? m : 0,
        bgcolor: bgcolor ? bgcolor : '#FFF',
      }}
    >
      {title && (
        <Typography variant={'h5'} color={titleColor ? titleColor : grey[900]}>
          {title}
        </Typography>
      )}
      {subTitle && (
        <Typography variant={'h6'} color={grey[500]}>
          {subTitle}
        </Typography>
      )}

      <CardContent>
        <Box
          display={'flex'}
          alignContent={align ? align : 'center'}
          justifyContent={align ? align : 'center'}
          flexDirection={'column'}
        >
          {img === 'folder' && (
            <img
              src={emToAbsoluteUrl('/static/assets/emptyfolder.jpeg')}
              style={{width: size, height: 'auto', margin: 'auto'}}
            ></img>
          )}
          {img === 'wind' && (
            <img
              src={emToAbsoluteUrl('/static/assets/windLeaf.jpeg')}
              style={{width: size, height: 'auto', margin: 'auto'}}
            ></img>
          )}
          {img === 'profile' && (
            <Box display={'flex'} justifyContent={'center'}>
              <PersonIcon sx={{fontSize: size, color: grey[300]}} />
            </Box>
          )}
          {img === 'business' && (
            <Box display={'flex'} justifyContent={'center'}>
              <BusinessIcon sx={{fontSize: size, color: grey[300]}} />
            </Box>
          )}
          {img === 'education' && (
            <Box display={'flex'} justifyContent={'center'}>
              <SchoolIcon sx={{fontSize: size, color: grey[300]}} />
            </Box>
          )}
          {img === 'experience' && (
            <Box display={'flex'} justifyContent={'center'}>
              <WorkIcon sx={{fontSize: size, color: grey[300]}} />
            </Box>
          )}
          {img === 'interests' && (
            <Box display={'flex'} justifyContent={'center'}>
              <InterestsIcon sx={{fontSize: size, color: grey[300]}} />
            </Box>
          )}
          {img === 'certifications' && (
            <Box display={'flex'} justifyContent={'center'}>
              <WorkspacePremiumIcon sx={{fontSize: size, color: grey[300]}} />
            </Box>
          )}
          {img === 'loading' && (
            <Box display={'flex'} justifyContent={'center'}>
              <HourglassTopIcon sx={{fontSize: size, color: grey[300]}} />
            </Box>
          )}
        </Box>
        {children}
      </CardContent>
    </Card>
  )
}
